export default __webpack_public_path__ + "static/media/sampling1.d2c50734.jpg";